<template>
  <div
    class="flex justify-center items-center bg-blue-very-light px-4 py-6 md:py-0 lg:h-32 rounded"
  >
    <div class="flex justify-center text-center">
      <icon :name="icon" class="text-5xl lg:text-6xl text-blue self-center" />

      <div class="block self-center ml-2 md:ml-12 md:w-2/3">
        <p class="font-bold text-gray-dark mb-2">
          {{ title }}
        </p>
        <p class="text-gray-dark">
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MaterialBanner',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: () => ({}),
  methods: {}
};
</script>
